import React from "react";
import { Chart } from "react-google-charts";
//import TenancyColor from '../midllers/TenancyColor'


function ChartFormaPG({ pg }) {
  const TenancyColorUser = localStorage.getItem('localcolorusers')
  // Formata os dados para o gráfico de pizza
  const data = [
    ["Forma de Pagamento", "Quantidade", "V.total"],
    ...pg.map(item => [item.forma_pgto, item.quantidade, item.valor_total]),
  ];
console.log(pg)
  // Definindo as opções do gráfico com cores personalizadas
  {/*const options = {
    colors: TenancyColorUser
      ? [TenancyColorUser]
      : ['#F3123C', '#F44D6D', '#C36678', '#C11938', '#963547'],
    legend: { position: 'bottom' },
  };*/}

  function shadeColor(color, percent) {
  const num = parseInt(color.slice(1), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) + amt;
  const G = ((num >> 8) & 0x00FF) + amt;
  const B = (num & 0x0000FF) + amt;

  return (
    "#" +
    (
      0x1000000 +
      (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
      (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
      (B < 255 ? (B < 1 ? 0 : B) : 255)
    )
      .toString(16)
      .slice(1)
  );
}

const options = {
  colors: TenancyColorUser
    ? [
        TenancyColorUser,
        shadeColor(TenancyColorUser, -18),
        shadeColor(TenancyColorUser, -14),
        shadeColor(TenancyColorUser, -10),
      ]
    : ['#F3123C', '#F44D6D', '#C36678', '#C11938'],
  legend: { position: 'bottom' },
};



  return (
    <div className="w100 h85 column center b2">
      <div className="w90">
       <h5 className="tx-lg fb3 c-dark m0">Formas de pagamento</h5>
      </div>
      <div className="w100 column celular">
        <div className="w100 row cell-tamanho90">
          <Chart
          chartType="PieChart"
          data={data}
          options={options}
          width="100%"
          height="300px"
          legendToggle
          />
        

        </div>
        <div className="w90 cell-tamanho90">
          Lista
          <div className="w100 row between pcb10 cell-tamanho">
            <label className="w30">Forma Pg</label>
            <label className="w30">Quantidade</label>
            <label className="w30">Valor total</label>
          </div>
          {pg.map(resp=>
            <div key={resp.id_baixa}>
              <div className="row between linha pcb10 w100 cell-tamanho">
                <label className="w33 fs09em fb">{resp.forma_pgto}</label>
                <label className="w30 fs09em">{resp.quantidade}</label>
                <label className="w30 fs09em">R$:{resp.valor_total}</label>
              </div>
            </div>
          )}
        </div>
      </div>
      
    </div>
  );
}

export default ChartFormaPG;
